import React from 'react';
import {CloseStrokeIcon, DeleteIcon} from "../../../../image";
import './DeleteProfilePhotoModal.scss';
import {useTranslation} from "react-i18next";
import {Modal} from "antd";
import {Button} from "../../../Button";

const DeleteProfilePhotoModal = (props) => {
	const {show, onClose, onConfirm} = props;
	const {t, i18n} = useTranslation();

	return (
		<Modal
			open={show}
			onCancel={onClose}
			centered
			classNames={{
				mask: 'delete-user-modal__mask',
				content: 'delete-user-modal__content',
				wrapper: 'delete-user-modal__wrapper',
			}}
			className={'delete-user-modal'}
			onWheel={(e) => e.stopPropagation()}
		>
			<div>
				<div className="delete-user-modal__header">
					<span className="delete-user-modal__header--title">
						{i18n.language === 'ru' ? 'Удалить из системы распознавания' : 'Remove from recognition'}
					</span>
					<CloseStrokeIcon onClick={onClose}/>
				</div>
				<div className="delete-user-modal__body">
					<span className="delete-user-modal__body--text">
							{ t('remove_photo_desc')}
						</span>
				</div>
				<div className="delete-user-modal__footer">
					<Button
						text={t('button_cancel')}
						onClick={onClose}
						variant={'secondary'}
						size={'m'}
					/>
					<Button
						text={t('remove')}
						onClick={onConfirm}
						variant={'secondary'}
						leftIcon={<DeleteIcon/>}
						color={"red"}
						size={'m'}
					/>
				</div>
			</div>
			
		</Modal>
	);
};

export default DeleteProfilePhotoModal;